export default __webpack_public_path__ + "static/media/100_19426.8fbbbc4d.jpg";